var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5"},[_c('v-row',{staticClass:"px-5",attrs:{"align":"center"}},[_c('span',{staticClass:"mr-5 headline"},[_vm._v(_vm._s(_vm.title))]),_c('v-divider',{staticStyle:{"box-shadow":"0px 0px 3px grey"}}),_vm._t("action")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }